import { render, staticRenderFns } from "./WorkTaskDialogFiles.vue?vue&type=template&id=7dfae3ee"
import script from "./WorkTaskDialogFiles.vue?vue&type=script&lang=ts"
export * from "./WorkTaskDialogFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports